import { render, staticRenderFns } from "./SupplierListComponent.vue?vue&type=template&id=5ed43298&"
import script from "./SupplierListComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports